
<div class="flex flex-row gap-2">
  <span [ngStyle]="{'color': colorClass}" class="text-m material-symbols-rounded" id="srs-vote-selection-icon" >{{ iconName }}</span>
  <button *ngIf="hasComment" (click)="openPopover(commentPopover)">
    <app-view-votes-popover
      #commentPopover
      id="srs-vote-comment-popover"
      popoverTitle="Ballot Comment"
      [votePopoverItems]="voteCommentPopoverItems"
    ></app-view-votes-popover>

    <span
      [class]="ViewVoteIconsConstants.chatBubble.colorClass"
      class="text-m material-symbols-rounded text-darkBlue-600"
      id="srs-vote-comment-icon"
    >
      {{ ViewVoteIconsConstants.chatBubble.iconName }}
    </span>
  </button>

  <button *ngIf="hasSupportingInformationDocument" (click)="openSupportingInformationDocumentsPopover(supportingInformationDocumentsPopover)">
    <app-view-vote-documents-popover
      #supportingInformationDocumentsPopover
      id="srs-supporting-information-document-popover"
      popoverTitle="Supporting Document"
    ></app-view-vote-documents-popover>
    <span
      [class]="ViewVoteIconsConstants.quickReference.colorClass"
      class="text-m material-symbols-rounded"
      id="srs-vote-document-icon">
      {{ ViewVoteIconsConstants.quickReference.iconName }}
    </span>
  </button>  

  <button *ngIf="showAuthorisationDocumentIcon" (click)="openAuthorisationDocumentsPopover(authorisationDocumentsPopover)">
    <app-view-vote-documents-popover
      #authorisationDocumentsPopover
      id="srs-authorisation-document-popover"
      popoverTitle="Authorisation Document"
    ></app-view-vote-documents-popover>
    <span
      [class]="ViewVoteIconsConstants.draft.colorClass"
      class="text-blue-500 text-m material-symbols-rounded"
      id="srs-vote-document-icon">
      {{ ViewVoteIconsConstants.draft.iconName }}
    </span>
  </button>

  <span
    *ngIf="hasAuthorisationDocument"
    [class]="ViewVoteIconsConstants.howToVote.colorClass"
    class="text-m material-symbols-rounded text-grey-800"
    id="srs-vote-proxy-vote-icon"
  >
    {{ ViewVoteIconsConstants.howToVote.iconName }}
  </span>

  <button *ngIf="hasHistories" (click)="openPopover(historyPopover)">
    <app-view-votes-popover
      #historyPopover
      id="srs-vote-history-popover"
      popoverTitle="Vote History"
      [votePopoverItems]="voteHistoryPopoverItems"
    ></app-view-votes-popover>
    <span
      [class]="ViewVoteIconsConstants.history.colorClass"
      class="text-m material-symbols-rounded text-grey-800"
      id="srs-vote-history-icon"
    >
      {{ ViewVoteIconsConstants.history.iconName }}
    </span>
  </button>
</div>
